export class ScrollSpy {
  constructor(selector) {
    this.selector = selector;
    this.el = document.querySelector(selector);
    this.anchors = null;
    this.sections = null;

    if (!this.el) {
      return;
    }

    this.anchors = [...this.el.querySelectorAll('.js-scrollspy-anchor')];
    this.sections = [...this.el.querySelectorAll('.js-scrollspy-section')];

    const observer = new IntersectionObserver((entries) => {
      entries.forEach((entry) => {
        if (entry.isIntersecting) {
          this.anchors.forEach((anchor) => {
            anchor.setAttribute('aria-current', 'false');
          });

          const anchor = this.anchors.find((anchor) => {
            return anchor.getAttribute('href') === `#${entry.target.id}`;
          });

          anchor.setAttribute('aria-current', 'true');
        }
      });
    }, {
      rootMargin: '-33% 0% -67%',
    })

    this.sections.forEach((section) => {
      observer.observe(section);
    });
  }
}
